import React, { useState, useRef, useEffect } from "react";
import classes from "./Navbar.module.css";
import {
  Avatar,
  AppBar,
  Toolbar,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../redux/reducers/auth";
import API from "../../../api/api_setting/apiConstants";
import { loaderActions } from "../../../redux/reducers/loader";
import { useLocation } from "react-router-dom";

const Navbar = ({ onMenuClick, isMobile }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const userData = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleMyAccount = () => {
    setOpen(false);
    navigate("/home/profile");
  };

  const handleLogOut = () => {
    setOpen(false);
    dispatch(loaderActions.toggleLoading(true));
    localStorage.removeItem(API.AUTH_TOKEN);
     window.location.reload();
     navigate("/login");
    dispatch(authActions.logout());
   
    dispatch(loaderActions.toggleLoading(false));
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        background: "white",
        color: "black",
        borderBottom: "1px solid #E0E0E0",
      }}
    >
      <Toolbar className={`${classes.navbar}`}>
        <div className="flex-row align-center">
          {isMobile && (
            <IconButton
              onClick={onMenuClick}
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <h3 style={{ margin: 0, fontWeight: 600, fontSize: "18px", color: "#222" }}>
            Dashboard
          </h3>
        </div>

        <div className={`flex-row ${classes.actions}`}>
          {/* Custom dropdown */}
          <div className={classes.dropdown_wrapper} ref={dropdownRef}>
            <Tooltip title="Account Settings">
              <Avatar
                src={userData.profileImg}
                variant="rounded"
                onClick={() => setOpen((prev) => !prev)}
                className="pointer"
              />
            </Tooltip>

            {open && (
              <div className={classes.dropdown}>
                {/* Profile header */}
                <div className={classes.dropdown_profile}>
                  <Avatar
                    src={userData.profileImg}
                    variant="rounded"
                    sx={{ width: 36, height: 36 }}
                  />
                  <div className={classes.dropdown_profile_info}>
                    <p className={classes.name}>{userData.name}</p>
                    <p className={classes.email}>{userData.email}</p>
                  </div>
                </div>

                <div className={classes.dropdown_divider} />

                <button
                  className={classes.dropdown_item}
                  onClick={handleMyAccount}
                >
                  Account Settings
                </button>

                <div className={classes.dropdown_divider} />

                <button
                  className={`${classes.dropdown_item} ${classes.dropdown_item_logout}`}
                  onClick={handleLogOut}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;